import { render, staticRenderFns } from "./DivorceAgreementPage.vue?vue&type=template&id=68f567e0&scoped=true"
import script from "./DivorceAgreementPage.vue?vue&type=script&lang=js"
export * from "./DivorceAgreementPage.vue?vue&type=script&lang=js"
import style0 from "./DivorceAgreementPage.vue?vue&type=style&index=0&id=68f567e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f567e0",
  null
  
)

export default component.exports